import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Divider, withStyles } from '@material-ui/core';
import ArchWordmark from './arch-wordmark.png';
import ArchPaper from '../../molecules/ArchPaper';

const styles = theme => ({
  root: {
    display: 'flex',
    height: '100vh',
    background: '#fafafa',
  },
  paper: {
    margin: 'auto',
    width: 280,
    height: 450,
    paddingTop: theme.spacing(6),
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    paddingTop: theme.spacing(2),
    width: 186,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonWrapper: {
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    width: '100%',
    marginTop: theme.spacing(3),
  },
  button: {
    position: 'relative',
    display: 'flex',
    padding: '0 0 0 48px',
    background: 'transparent',
    alignItems: 'center',
    width: '100%',
    height: '48px',
    fontSize: '14px',
    border: '1px solid #b3bac7',
    borderRadius: '3px',
    cursor: 'pointer',
    outline: '0',
    transition: 'background-color 0.25s ease-in-out',
    marginBottom: '8px',

    '&:hover': {
      background: 'rgba(47, 70, 100, .08)',
    },
  },
  buttonImage: {
    width: 16,
    left: 16,
    position: 'absolute',
    display: 'inline-block',
    top: '0px',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
  },
  microsoftSigninImage: {
    backgroundImage:
      'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY25fbWljcm9zb2Z0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9Imljbl9taWNyb3NvZnQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJtcy1zeW1ib2xsb2NrdXBfbXNzeW1ib2xfMTkiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjRjI1MDIyIiB4PSIwIiB5PSIwIiB3aWR0aD0iOS40NzM2ODQyMSIgaGVpZ2h0PSI5LjQ3MzY4NDIxIj48L3JlY3Q+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiMwMEE0RUYiIHg9IjAiIHk9IjEwLjUyNjMxNTgiIHdpZHRoPSI5LjQ3MzY4NDIxIiBoZWlnaHQ9IjkuNDczNjg0MjEiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzdGQkEwMCIgeD0iMTAuNTI2MzE1OCIgeT0iMCIgd2lkdGg9IjkuNDczNjg0MjEiIGhlaWdodD0iOS40NzM2ODQyMSI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjRkZCOTAwIiB4PSIxMC41MjYzMTU4IiB5PSIxMC41MjYzMTU4IiB3aWR0aD0iOS40NzM2ODQyMSIgaGVpZ2h0PSI5LjQ3MzY4NDIxIj48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)',
  },

  googleSigninImage: {
    backgroundImage:
      'url(data:image/svg+xml;base64,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)',
  },
  oktaSigninImage: {
    backgroundImage:
      'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkgKDUxMDAyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uLWxvZ2luLW9rdGE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXNzZXRzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iRGVza3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwNy4wMDAwMDAsIC02MDguMDAwMDAwKSI+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMyIgc3Ryb2tlPSIjOTc5Nzk3IiB4PSIxMTQuNSIgeT0iNTk5LjUiIHdpZHRoPSIyNzMiIGhlaWdodD0iNDQiIHJ4PSI0Ij48L3JlY3Q+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMjEsNjI4Ljk1NjE5NSBDMjE3LjE1ODIxOCw2MjguOTU2MTk1IDIxNC4wNDM4MDUsNjI1Ljg0MTc4MiAyMTQuMDQzODA1LDYyMiBDMjE0LjA0MzgwNSw2MTguMTU4MjE4IDIxNy4xNTgyMTgsNjE1LjA0MzgwNSAyMjEsNjE1LjA0MzgwNSBDMjI0Ljg0MTc4Miw2MTUuMDQzODA1IDIyNy45NTYxOTUsNjE4LjE1ODIxOCAyMjcuOTU2MTk1LDYyMiBDMjI3Ljk1NjE5NSw2MjUuODQxNzgyIDIyNC44NDE3ODIsNjI4Ljk1NjE5NSAyMjEsNjI4Ljk1NjE5NSBNMjIxLDYwOCBDMjEzLjI2ODAwNSw2MDggMjA3LDYxNC4yNjgwMDUgMjA3LDYyMiBDMjA3LDYyOS43MzE5OTUgMjEzLjI2ODAwNSw2MzYgMjIxLDYzNiBDMjI4LjczMTk5NSw2MzYgMjM1LDYyOS43MzE5OTUgMjM1LDYyMiBDMjM1LDYxNC4yNjgwMDUgMjI4LjczMTk5NSw2MDggMjIxLDYwOCIgaWQ9Imljb24tbG9naW4tb2t0YSIgZmlsbD0iIzAwN0RDMSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)',
  },
});

function LoginScreen({ classes, onSigninClick }) {
  return (
    <div className={classes.root}>
      <ArchPaper elevation={1} className={classes.paper}>
        <img
          src={ArchWordmark}
          className={classes.logo}
          alt="arch platform technologies logo"
        />

        <Divider className={classes.divider} />
        <div className={classes.buttonWrapper}>
          <button
            className={classes.button}
            type="submit"
            onClick={() => Auth.federatedSignIn({ provider: 'Google' })}
          >
            <div
              className={cx(classes.googleSigninImage, classes.buttonImage)}
              alt="Log in with Google"
            />

            <div className={classes.loginText}>Log in with Google</div>
          </button>

          <button
            className={classes.button}
            type="submit"
            onClick={() => Auth.federatedSignIn({ provider: 'Microsoft' })}
          >
            <div
              className={cx(classes.microsoftSigninImage, classes.buttonImage)}
              alt="Log in with Microsoft"
            />
            <div className={classes.loginText}>Log in with Microsoft</div>
          </button>

          {process.env.REACT_APP_OKTA_PROVIDER && (
            <button
              className={classes.button}
              type="submit"
              onClick={() =>
                Auth.federatedSignIn({
                  provider: process.env.REACT_APP_OKTA_PROVIDER,
                })
              }
            >
              <div
                className={cx(classes.oktaSigninImage, classes.buttonImage)}
                alt="Log in with Okta"
              />
              <div className={classes.loginText}>Log in with Okta</div>
            </button>
          )}
        </div>
      </ArchPaper>
    </div>
  );
}

LoginScreen.propTypes = {
  onSigninClick: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(LoginScreen);
